import type React from 'react';

import type { IconProps } from 'types/icon';

const DeliveryVan: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M12.5829 14.1666C12.5829 13.2462 13.3293 12.5001 14.2496 12.4999C15.1701 12.4999 15.9163 13.2461 15.9163 14.1666C15.9163 15.0871 15.1701 15.8333 14.2496 15.8333C13.3293 15.833 12.5829 15.0869 12.5829 14.1666ZM4.16659 14.1666C4.16659 13.2461 4.91278 12.4999 5.83325 12.4999C6.75373 12.4999 7.49992 13.2461 7.49992 14.1666C7.49992 15.0871 6.75373 15.8333 5.83325 15.8333C4.91278 15.8333 4.16659 15.0871 4.16659 14.1666ZM2.49992 6.24992C2.49992 5.09933 3.43266 4.16659 4.58325 4.16659H11.2499C11.9403 4.16659 12.4999 4.72623 12.4999 5.41659V12.3819C12.2309 12.6458 12.0236 12.9706 11.8953 13.3333H8.1884C7.84497 12.3627 6.92146 11.6666 5.83325 11.6666C4.79346 11.6666 3.90218 12.3015 3.52531 13.2047C2.92329 12.9534 2.49992 12.3597 2.49992 11.6666V6.24992ZM17.4999 12.0833C17.4999 12.6564 17.1137 13.1377 16.5876 13.2852C16.231 12.3399 15.3198 11.6666 14.2496 11.6666C13.9259 11.6666 13.6171 11.7295 13.3333 11.8416V5.83325H14.7045C15.4936 5.83325 16.2152 6.27906 16.5681 6.98478L17.2802 8.40812C17.4248 8.69736 17.4999 9.01655 17.4999 9.33992V12.0833ZM1.66659 11.6666C1.66659 12.7565 2.36516 13.6804 3.33813 14.0225C3.33543 14.0702 3.33325 14.1182 3.33325 14.1666C3.33325 15.5473 4.45254 16.6666 5.83325 16.6666C7.21396 16.6666 8.33325 15.5473 8.33325 14.1666H11.7496C11.7496 15.5472 12.8691 16.6664 14.2496 16.6666C15.6303 16.6666 16.7496 15.5473 16.7496 14.1666C16.7496 14.1456 16.7493 14.1248 16.7488 14.1039C17.6582 13.8802 18.3333 13.0617 18.3333 12.0833V9.33992C18.3332 8.88718 18.2281 8.44035 18.0256 8.0354L17.3136 6.61206C16.8195 5.62402 15.8092 4.99992 14.7045 4.99992H13.2917C13.0987 4.04897 12.2578 3.33325 11.2499 3.33325H4.58325C2.97242 3.33325 1.66659 4.63909 1.66659 6.24992V11.6666Z"
        fill={color}
      />
    </svg>
  );
};

export default DeliveryVan;
